// src/admin/components/ClientAccordion.jsx
//
// Collapsible per-client section: client name + financial summary,
// with a "View Camps" toggle that expands to show locations -> camps.

import React, { useState } from 'react';
import ClientFinancialSummary from './ClientFinancialSummary';
import LocationGroup from './LocationGroup';

function IconChevronDown(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
    </svg>
  );
}

export default function ClientAccordion({ client }) {
  const [open, setOpen] = useState(false);
  const locations = client?.locations || [];

  return (
    <div className="rounded-xl border border-[#E2E8E8] bg-white shadow-sm">
      <div className="flex flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 sm:w-48 sm:shrink-0">
          <h3 className="truncate text-base font-bold text-[#172B2B]">
            {client?.client_name || 'Unknown Client'}
          </h3>
        </div>

        <div className="flex-1">
          <ClientFinancialSummary client={client} />
        </div>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="flex shrink-0 items-center gap-1.5 self-start rounded-lg border border-[#E2E8E8] bg-white px-3 py-1.5 text-xs font-semibold text-[#0D8F8C] shadow-sm transition-colors hover:bg-[#E8F8F7] sm:self-center"
        >
          {open ? 'Hide Camps' : 'View Camps'}
          <IconChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {open && (
        <div className="space-y-3 border-t border-[#E2E8E8] px-5 py-4">
          {locations.length === 0 ? (
            <p className="text-sm text-[#6B7C7C]">No locations found for this client.</p>
          ) : (
            locations.map((loc, idx) => (
              <LocationGroup key={`${client?.client_id}-${loc.location}-${idx}`} location={loc} />
            ))
          )}
        </div>
      )}
    </div>
  );
}
